import { getHeaders, http } from './http';

export { getHeaders };

export const cadastrarCredencial = async (dados, options = {}) => {
    return http.post(`/credenciais/cadastro`, dados, options);
};

export const atualizarCredencial = async (id, dados, options = {}) => {
    return http.put(`/credenciais/${id}`, dados, options);
};

export const listarPacsCredencial = async (options = {}) => {
    return http.get(`/credenciais/pacs-aetitle`, options);
};

export const listarCredenciais = async (params, options = {}) => {
    return http.get(`/credenciais/listar-credenciais`, { params, ...options });
};

export const verificarLoginUnico = async (params, options = {}) => {
    return http.get(`/credenciais/verificar-login`, { params, ...options });
};

export const ativarInativar = async (id, options = {}) => {
    return http.get(`/credenciais/situacao/${id}`, { ...options });
};

export const listarParceiros = async (params, options = {}) => {
    return http.get(`/parceiros/listar-parceiros`, { params, ...options });
};

export const alternarAtivoParceiro = async (id, options = {}) => {
    return http.get(`/parceiros/ativo/${id}`, { ...options });
};

export const inserirParceiro = async (dados, options = {}) => {
    return http.post(`/parceiros/inserir`, dados, options);
};

export const atualizarParceiro = async (id, dados, options = {}) => {
    return http.put(`/parceiros/${id}`, dados, options);
};

export const verificarUrlUnica = async (params, options = {}) => {
    return http.get(`/parceiros/verificar-url`, { params, ...options });
};

export const listarSchemasModulosParceiro = async (options = {}) => {
    return http.get(`/parceiros/schemas-modulos`, { ...options });
};

export const obterConfigModuloParceiro = async (id, sigla, options = {}) => {
    // GET admin por _id (não confundir com /parceiros/{url}/config/{sigla} do runtime).
    return http.get(`/parceiros/por-id/${encodeURIComponent(String(id))}/config/${encodeURIComponent(sigla)}`, {
        ...options,
    });
};

export const salvarConfigModuloParceiro = async (id, sigla, dados, options = {}) => {
    return http.put(`/parceiros/${encodeURIComponent(String(id))}/config/${encodeURIComponent(sigla)}`, dados, options);
};

export const pesquisarAdministradoresParceiro = async (id, options = {}) => {
    return http.get(`/parceiros/${encodeURIComponent(String(id))}/administradores`, { ...options });
};

export const salvarAdministradoresParceiro = async (id, dados, options = {}) => {
    return http.put(`/parceiros/${encodeURIComponent(String(id))}/administradores`, dados, options);
};

export const listarModulos = async (params, options = {}) => {
    return http.get(`/modulos/listar-modulos`, { params, ...options });
};

export const alternarAtivoModulo = async (id, options = {}) => {
    return http.get(`/modulos/ativo/${id}`, { ...options });
};

export const inserirModulo = async (dados, options = {}) => {
    return http.post(`/modulos/inserir`, dados, options);
};

export const atualizarModulo = async (id, dados, options = {}) => {
    return http.put(`/modulos/${id}`, dados, options);
};

export const verificarSiglaUnica = async (params, options = {}) => {
    return http.get(`/modulos/verificar-sigla`, { params, ...options });
};

export const obterModulo = async (id, options = {}) => {
    return http.get(`/modulos/por-id/${encodeURIComponent(String(id))}`, { ...options });
};

export const pesquisarValoresInstancia = async (sigla, configId, options = {}) => {
    return http.get(`/modulos/valores/${encodeURIComponent(String(sigla))}`, {
        params: { config_id: configId },
        ...options,
    });
};

export const gerarUrlUploadImagem = async (dados, options = {}) => {
    return http.post(`/imagem/gerar-url-upload`, dados, options);
};
